<template>
  <div id="reservation">
    <div class="page-container" id="reservation-container">
      <div class="page-content" id="reservation-content">
        <header id="main-menu" class="logo-header">
          <div class="store-info menu-content">
            <div class="logo-col">
              <img :src="storeLogo" />
            </div>
            <div class="store-name">
              <h1>{{ storeName }}</h1>
            </div>
          </div>
        </header>

        <nav id="main-nav" class="detail-nav">
          <div class="reservation-tips-grid">
            <div class="tip-grid-col">
              <div>
                <span class="icon-users"></span>
                <div id="grid-number-col">{{ currentSize }}</div>
              </div>
            </div>
            <div class="tip-grid-col">
              <div>
                <span class="icon-calendar-alt-fill"></span>
                <div id="grid-date-col">{{ currentDate }}</div>
              </div>
            </div>
            <div class="tip-grid-col">
              <div>
                <span class="icon-clock2"></span>
                <div
                  id="grid-time-col"
                  data-sort=""
                  data-tab="0"
                  data-time-tab="0"
                >
                  {{ currentTime }}
                </div>
              </div>
            </div>
          </div>
        </nav>
        <article
          class="swiper-container"
          id="swiper-container"
          v-show="!loadingShow"
        >
          <div class="swiper-wrapper">
            <section id="page-5" class="swiper-slide swiper-no-swiping">
              <div class="orderDetial-mod">
                <div id="orderDetial-mod">
                  <ul class="order-details">
                    <li class="name-col">
                      <div class="col-label">Name:</div>
                      <strong id="orderName">
                        <span id="orderFirstName">{{ infoForm.firstName }}</span
                        >&nbsp;<span id="orderLastName">{{
                          infoForm.surname
                        }}</span>
                      </strong>
                    </li>
                  </ul>
                  <ul class="order-details">
                    <li class="email-col">
                      <div class="col-label">Email:</div>
                      <strong id="orderEmail">{{ infoForm.email }}</strong>
                    </li>
                  </ul>
                  <ul class="order-details">
                    <li class="phone-col">
                      <div class="col-label">Phone:</div>
                      <strong id="orderPhone">
                        <span
                          v-show="
                            infoForm.areaCode !== '' ||
                            infoForm.areaCode !== ' '
                          "
                          >{{ infoForm.areaCode }}
                        </span>
                        {{ infoForm.phone }}
                      </strong>
                    </li>
                  </ul>
                  <ul
                    class="order-details flex"
                    id="depositCol"
                    v-show="depositPrice !== ''"
                  >
                    <li class="deposit-col flex3">
                      <div class="col-label">Deposit:</div>
                      <strong id="orderDeposit"
                        >&pound;{{ depositPrice }}</strong
                      >
                    </li>
                    <li class="people-col flex1">
                      <div class="col-label">People:</div>
                      <strong id="orderPeople">{{ currentSize }} px</strong>
                    </li>
                  </ul>
                  <ul class="order-details flex">
                    <li class="date-col flex2">
                      <div class="col-label">Date:</div>
                      <strong id="orderDate">{{ currentDate }}</strong>
                    </li>
                    <li class="week-col flex1">
                      <div class="col-label">On:</div>
                      <strong id="orderWeek">{{ week }}</strong>
                    </li>
                    <li class="time-col flex1">
                      <div class="col-label">Time:</div>
                      <strong id="orderTime">{{ currentTime }}</strong>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="buttons-col">
                <button
                  @click="confirmReserve(res_id)"
                  id="confirmReserveBtn"
                  class="btn confirmStyle"
                  type="button"
                >
                  <span class="ladda-label">Confirm Reservation</span>
                </button>
                <button
                  @click="startCancel"
                  id="cancelReserveBtn"
                  class="btn cancelStyle"
                  type="button"
                >
                  <span class="ladda-label">Cancel Reservation</span>
                </button>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import axios from "axios";
import Loading from "../components/loading.vue";
import { configTheme } from "@/utils/theme";
import { Modal } from "ant-design-vue";
export default {
  name: "BookingView",
  components: {
    Loading,
  },

  data() {
    return {
      storeLogo: "",
      storeName: "",
      storePhone: "",
      isHidden: true,
      paramsValid: true,
      currentPage: 0,
      week: "Wednesday",
      currentSize: "5",
      currentDate: "10 Jun 2020",
      currentTime: "08:30",
      infoForm: {
        firstName: "Eric",
        surname: "Guo",
        areaCode: "+44",
        phone: "12345678901",
        email: "BBBddd@AAa.org",
      },
      read: true,
      selectedDate: "",
      store_id: 0,
      showCancelAlert: false,
      cancelConfirmed: false,
      res_id: 0,
      loadingShow: true,
      depositPrice: "44.00",
    };
  },
  computed: {},
  created() {
    var reserve_number = this.$route.params.reserve_number;
    this.res_id = reserve_number;
    this.getReserveData(reserve_number);
  },

  methods: {
    getStoreData(store_name) {
      axios
        .get(process.env.API_URL + "htmlReserve/getStoreData", {
          params: { store_name },
        })
        .then((res) => {
          console.log(res);
          this.store_id = res.data.data.store_id;
          this.storeName = res.data.data.store_name;
          this.storePhone = res.data.data.contact_phone;
          this.storeLogo = res.data.data.logo;

          if (res.data.data.style_status == 1) {
            console.log(res.data.data.style_content);
            this.customTheme = res.data.data.style_content;
            const { brandColor, fontColor } = this.customTheme;
            configTheme(brandColor, fontColor);
          } else {
            configTheme("#f08a24", "#000000");
          }
        });
    },
    getReserveData(res_id) {
      axios
        .get(process.env.API_URL + "htmlReserve/getReserveData", {
          params: { reserve_id: res_id },
        })
        .then((res) => {
          if (res.data.data.status == 4) {
            this.cancelConfirmed = true;
            this.isHidden = false;
          }
          this.getStoreData(res.data.data.store_name);
          this.infoForm.firstName = res.data.data.cust_first_name;
          this.infoForm.surname = res.data.data.cust_surname;
          this.currentDate = res.data.data.date;
          this.week = res.data.data.wekday;
          this.currentTime = res.data.data.r_time;
          this.currentSize = res.data.data.covers;
          this.infoForm.phone = res.data.data.cust_phone;
          this.infoForm.email = res.data.data.cust_email;
          this.depositPrice = res.data.data.ned_pay;
          if (res.data.data.slogo != 1) {
            this.storeLogo = res.data.data.slogo;
          }
          this.loadingShow = false;
        });
    },
    confirmReserve(res_id) {
      axios
        .post(process.env.API_URL + "htmlReserve/confirmReserve", {
          params: { res_id, flag: 1 },
        })
        .then((res) => {
          const h = this.$createElement;
          Modal.info({
            title: h("div", {}, [
              h("p", "Thank you for your reservation."),
              h("p", "Your booking has been confirmed."),
            ]),
            icon: "",
            iconType: "",
            content: "",
            onOk() {},
            onCancel() {},
          });
        });
    },
    startCancel() {
      const h = this.$createElement;
      const res_id = this.res_id;
      Modal.confirm({
        title: "Cancel your reservation?",
        icon: "",
        iconType: "",
        content: "Are you sure you wish to cancel your booking?",
        onOk() {
          axios
            .post(process.env.API_URL + "htmlReserve/confirmReserve", {
              params: { res_id, flag: 2 },
            })
            .then((res) => {
              Modal.info({
                title: h("div", {}, [
                  h("p", "Your booking has been cancelled."),
                  h("p", "We're sorry you couldn't make it."),
                ]),
                icon: "",
                iconType: "",
                content: "",
                onOk() {},
                onCancel() {},
              });
            });
        },
        onCancel() {},
      });
    },
    cancelConfirm(res_id) {
      this.loadingShow = true;
      axios
        .post(process.env.API_URL + "htmlReserve/confirmReserve", {
          params: { res_id: res_id, flag: 2 },
        })
        .then((res) => {
          this.cancelConfirmed = true;
          this.loadingShow = false;
        });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped="scoped">
#reservation article.swiper-container {
  top: 0;
}
#reservation nav.detail-nav {
  border-top: 0;
  border-bottom: 0;
}
#reservation #page-1 {
  padding-top: 20px;
}
#reservation #confirmedTips {
  text-align: center; /* margin-bottom: 300px;*/
}
#reservation #confirmedTips ul {
  background: rgba(238, 238, 252, 1);
}
#reservation #confirmedTips li {
  width: 100%;
  text-align: center;
}
#reservation .buttons-col {
  padding: 30px 26px 10px;
  position: relative;
}
#reservation .buttons-col button {
  position: relative;
  width: calc(100%);
  display: block;
  margin-bottom: 20px;
  font-size: 16px;
  padding: 15px 0;
  border-radius: 8px;
  box-shadow: 5px 5px 10px rgba(5, 5, 5, 0.2), -3px -3px 3px rgba(6, 6, 6, 0.05);
  font-weight: 700;
}
#reservation .buttons-col button.confirmStyle {
  // background: linear-gradient(135deg, #6e8efb, #a777e3);
  // background: #6e8efb;
  background-color: var(--brandColor);
  color: #fff;
  border: none;
}
#reservation .buttons-col button.cancelStyle {
  // background: rgb(238, 238, 252);
  border: 2px solid var(--brandColor);
  background-color: var(--brandColor10);
}
#reservation .buttons-col button.confirmStyle:hover,
#reservation .buttons-col button.confirmStyle:active {
  background: linear-gradient(135deg, #a777e3, #6e8efb);
  background: #a777e3;
}
#reservation .buttons-col button.cancelStyle:hover,
#reservation .buttons-col button.cancelStyle:active {
  background: #fff;
}
#reservation .cancelStyleTips {
  padding: 0 20px;
}
#reservation .cancelStyleTips .alertBody {
  background: rgba(238, 238, 252, 1);
  padding: 20px;
}
#reservation .cancelStyleTips .alertBody .titleCol {
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
#html-loading {
  top: 0;
  width: 100%;
  height: 100%;
}
#html-loading .sk-circle {
  top: 40%;
}
.pace-done #html-loading {
  display: block;
}

#main-menu,
#main-nav,
#main-title {
  width: 100%;
  position: relative !important;
  transform: unset !important;
  max-width: unset !important;
  top: unset !important;
  left: unset !important;
}
.swiper-container {
  overflow-y: auto !important;
  padding-top: 0 !important;
}

.tip-grid-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (min-width: 640px) {
  #reservation .buttons-col button {
  }
  #reservation article.swiper-container {
    padding-top: calc(50px + 31px);
    top: 0;
  }
  #reservation .buttons-col button {
    width: 300px;
    margin: 0 auto 20px;
  }
}
</style>

<style>
.ant-modal-confirm-title {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/BookingView.vue